import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from "reactstrap";
import {FormattedMessage} from "react-intl";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import {connect} from "react-redux";
import {addJavascript} from "scenes/Survey/Structure/data/javascripts/actions";
import JavascriptForm from "./JavascriptForm";


class AddJavascriptButton extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false,
      saving: false,
      errors: {},
    };

    this.form = React.createRef();

    this.toggleModal = this.toggleModal.bind(this);
    this.saveJavascript = this.saveJavascript.bind(this);
  }

  toggleModal() {
    this.setState({
      modalOpen: !this.state.modalOpen,
    })
  }

  saveJavascript(){
    const {question} = this.props;
    const data = this.form.current.state.data;

    this.setState({
      saving: true,
      errors: {},
    });

    this.props.addJavascript({
      question,
      data,
    }).then(data => {
      this.setState({
        saving: false,
        modalOpen: false,
      });
    }).catch(res => {
      this.setState({
        saving: false,
        errors: res.response.data.form.errors,
      });
    })

  }

  render() {
    const {modalOpen, saving, errors} = this.state;
    const {question} = this.props;

    const modal = <Modal isOpen={modalOpen} toggle={this.toggleModal} size="xl">
      <ModalHeader toggle={this.toggleModal}>Kod JavaScript</ModalHeader>
      <hr className="my-0" />
      <ModalBody>
        <JavascriptForm ref={this.form} javascriptActions={question.javascriptActions} errors={errors} />
      </ModalBody>
      <ModalFooter>
        <FormattedMessage id="_.button.cancel">{
          (message) =>
            <Button color="secondary" className="mb-0" onClick={this.toggleModal}>{message}</Button>
        }</FormattedMessage>
        <FormattedMessage id="_.button.save">{
          (message) => <LaddaButton
            className="btn btn-primary btn-ladda mb-0"
            loading={saving}
            data-style={ZOOM_OUT}
            onClick={this.saveJavascript}
          >
            {message}
          </LaddaButton>
        }</FormattedMessage>
      </ModalFooter>
    </Modal>;

    return (
      <React.Fragment>
        <Button color="primary" onClick={this.toggleModal}>
          Dodaj nowy kod JS
        </Button>
        {modal}
      </React.Fragment>
    );
  }
}

AddJavascriptButton.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    javascriptActions: PropTypes.array.isRequired,
  }).isRequired,
};

export default connect(null, {addJavascript})(AddJavascriptButton);